export default "__VITE_ASSET__rgp1dVKb__"